<template>
  <label class="circle-checkbox" :class="checkboxClass">
    <input
      type="checkbox"
      :checked="checked"
      v-bind="$attrs" />
    <div></div>
  </label>
</template>

<script lang="ts">
import type { PropType } from "vue";
import BaseIcon from "~/components/icons/BaseIcon.vue";

export default defineNuxtComponent({
  components: { BaseIcon },
  props: {
    checked: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  inheritAttrs: false,
  setup(props) {
    const checkboxClass = computed(() => ({
      "circle-checkbox_checked": props.checked,
    }));

    return {
      checkboxClass,
    };
  },
});
</script>
